import { mailModuleName } from './strings.locstring.json';
import loc from 'owa-localize';
// Order is important, do not mess with it :)
import * as React from 'react';
import { bootstrap } from 'owa-bootstrap';
import initializeMailModuleState from './actions/initializeMailModuleState';
import MailModule from 'owa-mail-module-view/lib/components/MailModule';
import { mailRouterOptions, initializeMailRoutes } from './routing/mailRoutes';
import { OwaWorkload } from 'owa-workloads';
import { controlIconRegistration } from 'owa-control-icons';
import { mailIconsRegistration } from 'owa-mail-icons';
import { addinIconsRegistration } from 'owa-addins-icons';
import { surfaceActionIconsRegistration } from 'owa-surface-action-icons';
import { getMailAnalyticOptions } from 'owa-mail-shared-analytics';
import 'owa-attachment-preview-initialization/lib/utils/initializeAttachmentPreviewInSxS';
import { PreBootOptions } from 'owa-config';
import {
    satchelDiagnosticsMiddleware,
    legacySatchelDiagnosticsMiddleware,
} from 'owa-diagnostics-common/lib/satchel/satchelDiagnosticsMiddleware';
import { lazySetupMailModulePostRender } from 'owa-mail-post-boot';

export default function bootstrapMailModule(bootstrapConfig: PreBootOptions): Promise<void> {
    return bootstrap({
        initializeState: initializeMailModuleState,
        renderMainComponent: () => <MailModule />,
        initialConfig: bootstrapConfig,
        registerRoutes: initializeMailRoutes,
        routerOptions: mailRouterOptions,
        getModuleName: () => loc(mailModuleName),
        workload: OwaWorkload.Mail,
        analyticsOptions: getMailAnalyticOptions(),
        iconFonts: [
            controlIconRegistration,
            mailIconsRegistration,
            addinIconsRegistration,
            surfaceActionIconsRegistration,
        ],
        satchelMiddleware: [satchelDiagnosticsMiddleware],
        satchelLegacyMiddleware: [legacySatchelDiagnosticsMiddleware],
        postLazyAction: lazySetupMailModulePostRender,
    });
}
